import Layer from './layer';

import Settings from '../settings';
import FontDefinition from '../font_definition';
import DataBlock from '../data_block';

export default class TextLayer extends Layer {
  /*
   * params:
   *   bounds: left, top, right, bottom
   *   crosshair: x, y
   *   cleanLayer: CleanLayer
   *   fontDefinition: FontDefinition
   */
  constructor(page, params) {
    super(page);
    this.type = 'text';

    if (params === undefined)
      return;

    if (!params.bounds) {
      if (params.cleanLayer) {
        if (params.crosshair) {
          params.bounds = {
            left: params.crosshair.x,
            top: params.crosshair.y,
            right: params.crosshair.x,
            bottom: params.crosshair.y
          };

          let x = params.crosshair.x;
          let y = params.crosshair.y;
          while (params.bounds.left >= 0 && params.cleanLayer.mask[y * this.page.width + params.bounds.left])
            params.bounds.left -= 1;
          while (params.bounds.right < this.page.width && params.cleanLayer.mask[y * this.page.width + params.bounds.right])
            params.bounds.right += 1;
          while (params.bounds.top >= 0 && params.cleanLayer.mask[params.bounds.top * this.page.width + x])
            params.bounds.top -= 1;
          while (params.bounds.bottom < this.page.height && params.cleanLayer.mask[params.bounds.bottom * this.page.width + x])
            params.bounds.bottom += 1;
        } else {
          params.bounds = {
            left: params.cleanLayer.x,
            top: params.cleanLayer.y,
            right: params.cleanLayer.x + params.cleanLayer.width,
            bottom: params.cleanLayer.y + params.cleanLayer.height
          };
        }
      } else {
        params.bounds = 'auto';
      }
    }

    if (!params.crosshair) {
      if (params.bounds == 'auto') {
        params.crosshair = {
          x: (page.width * 0.5)|0,
          y: (page.height * 0.5)|0
        };
      } else {
        params.crosshair = {
          x: params.bounds.left + (((params.bounds.right - params.bounds.left) * 0.5)|0),
          y: params.bounds.top + (((params.bounds.bottom - params.bounds.top) * 0.5)|0)
        };
      }
    }

    if (!params.fontDefinition) {
      params.fontDefinition = new FontDefinition();
    }

    if (params.bounds == 'auto') {
      this.x = params.crosshair.x;
      this.y = params.crosshair.y;
      this.width = 1;
      this.height = 1;
      this.boundsMode = 'auto';
    } else {
      this.x = params.bounds.left;
      this.y = params.bounds.top;
      this.width = params.bounds.right - params.bounds.left;
      this.height = params.bounds.bottom - params.bounds.top;
      this.boundsMode = 'extend';
    }

    let centerX = this.x + this.width * 0.5;
    let centerY = this.y + this.height * 0.5;
    this.textBounds = {
      left: centerX,
      top: centerY,
      right: centerX,
      bottom: centerY
    };

    this.baseSize = {
      width: this.width,
      height: this.height
    };

    this.crosshair = params.crosshair;
    this.cleanLayer = params.cleanLayer;
    this.fontDefinition = new FontDefinition();
    this.fontDefinition.import(params.fontDefinition.export());

    this.angle = 0;

    this.text = '';

    this.canvas = document.createElement('canvas');
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.context = this.canvas.getContext('2d');
  }

  setBoundsMode(mode) {
    this.boundsMode = mode;
    this.update();
  }

  move(x, y) {
    this.x += x;
    this.y += y;
    this.crosshair.x += x;
    this.crosshair.y += y;
    this.textBounds.left += x;
    this.textBounds.top += y;
    this.textBounds.right += x;
    this.textBounds.bottom += y;

    if (this.page.selectedLayer == this && this.page.selection) {
      this.page.selection = {
        left: this.x,
        top: this.y,
        right: this.x + this.width,
        bottom: this.y + this.height
      };
    }

    this.page.update();
    this.page.triggerEvent('update');
  }

  findRealTextBounds() {
    let centerX = this.width * 0.5;
    let centerY = this.height * 0.5;
    let bounds = {
      left: centerX|0,
      top: centerY|0,
      right: centerX|0,
      bottom: centerY|0
    };

    let imgData = this.context.getImageData(0, 0, this.width, this.height).data;
    for (let i = 3, j = 0; i < imgData.length; i += 4, j++) {
      if (imgData[i] > 0) {
        let x = j % this.width;
        let y = Math.floor(j / this.width);
        bounds.left = Math.min(bounds.left, x);
        bounds.top = Math.min(bounds.top, y);
        bounds.right = Math.max(bounds.right, x);
        bounds.bottom = Math.max(bounds.bottom, y);
      }
    }

    bounds.left += this.x;
    bounds.top += this.y;
    bounds.right += this.x;
    bounds.bottom += this.y;

    return bounds;
  }

  // вызывать этот метод только при изменении текста или шрифта
  update() {
    this.name = this.text;

    let ctx = this.context;
    let fd = this.fontDefinition;

    if (this.text == '') {
      if (this.boundsMode == 'auto') {
        this.x = this.crosshair.x;
        this.y = this.crosshair.y;
        this.width = 1;
        this.height = 1;

        let centerX = this.x + this.width * 0.5;
        let centerY = this.y + this.height * 0.5;
        this.textBounds = {
          left: centerX,
          top: centerY,
          right: centerX,
          bottom: centerY
        };

        this.canvas.width = this.width;
        this.canvas.height = this.height;
      }

      ctx.clearRect(0, 0, this.width, this.height);
      return;
    }


    let root = document.createElement('div');
    let el = document.createElement('div');
    let txt = document.createTextNode(this.text);
    el.appendChild(txt);
    el.setAttribute('style', fd.css().split("\n").join(' ') + `; transform: rotate(${parseFloat(this.angle)|0}deg)`);
    el.style.whiteSpace = 'pre';
    el.style.display = 'inline-block';
    root.appendChild(el);

    root.style.visibility = 'hidden';
    document.body.appendChild(root);

    let imgBounds = el.getBoundingClientRect();

    let centerX = this.x + this.width * 0.5;
    let centerY = this.y + this.height * 0.5;
    this.textBounds = {
      left: centerX - imgBounds.width * 0.5,
      top: centerY - imgBounds.height * 0.5,
      right: centerX + imgBounds.width * 0.5,
      bottom: centerY + imgBounds.height * 0.5
    };

    let imgWidth = Math.ceil(imgBounds.width + (fd.fontSize|0));
    let imgHeight = Math.ceil(imgBounds.height + (fd.fontSize|0));

    let style = el.getAttribute('style') + `display: flex; position: absolute; left: 0; top: 0; width: ${imgWidth}px; height: ${imgHeight}px; `;

    let el2 = el.cloneNode();
    el.setAttribute('style', style + '-webkit-text-fill-color: transparent;');
    el2.setAttribute('style', style + '-webkit-text-stroke: 0;');
    let txt2 = document.createTextNode(this.text);
    el2.appendChild(txt2);
    root.appendChild(el2);

    let html = root.innerHTML;
    html = html.split("\n").join('<br />');


    root.remove();

    let data = `<svg xmlns="http://www.w3.org/2000/svg" width="${imgWidth}" height="${imgHeight}"><foreignObject width="100%" height="100%"><div style="position: relative" xmlns="http://www.w3.org/1999/xhtml">${html}</div></foreignObject></svg>`;
    let img = new Image();
    let url = 'data:image/svg+xml,' + data;

    img.crossOrigin = "Anonymous";
    img.onload = () => {
      if (this.boundsMode != 'fixed') {
        let newWidth, newHeight;

        if (this.boundsMode == 'auto') {
          newWidth = img.width;
          newHeight = img.height;
        } else {
          newWidth = Math.max(img.width, this.baseSize.width);
          newHeight = Math.max(img.height, this.baseSize.height);
        }

        let dw = this.width - newWidth;
        let dh = this.height - newHeight;

        this.x = (this.x + dw * 0.5)|0;
        this.y = (this.y + dh * 0.5)|0;
        this.width = newWidth;
        this.height = newHeight;

        this.canvas.width = this.width;
        this.canvas.height = this.height;

        if (this.page.selectedLayer == this && this.page.selection) {
          this.page.selection = {
            left: this.x,
            top: this.y,
            right: this.x + this.width,
            bottom: this.y + this.height
          };
        }
      }

      let textX = 0;
      if (fd.textAlign == 'center') {
        textX = ((this.width - img.width) * 0.5);
      } else if (fd.textAlign == 'right') {
        textX = this.width - img.width;
      }
      let textY = 0;
      if (fd.verticalAlign == 'center') {
        textY = ((this.height - img.height) * 0.5);
      } else if (fd.verticalAlign == 'bottom') {
        textY = this.height - img.height;
      }

      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      ctx.drawImage(img, textX, textY);

      this.page.update();
      this.page.triggerEvent('update');
    };

    img.src = url;
  }

  exportBinary() {
    let extra = new DataBlock();

    extra.putDouble(this.baseSize.width, this.baseSize.height);

    extra.putString(this.boundsMode);
    extra.putDouble(this.crosshair.x, this.crosshair.y);
    extra.put4(this.cleanLayer ? this.cleanLayer.id : 0);
    extra.putString(this.text);

    let fd = this.fontDefinition.exportBinary();
    extra.put4(fd.length);
    extra.put(fd);

    extra.putDouble(parseFloat(this.angle)|0);

    return this.__exportBinary(extra);
  }
}
